import { SmartfireComponent, smartProps } from "@smartfire/gutenberg-react";
import React from "react";
import "./style.scss";
import "./editor.scss";
import { PlainText } from "@wordpress/editor";

export default class PlusButton extends SmartfireComponent {
  static smartProps = {
    buttonText: smartProps.string.isRequired,
    buttonUrl: smartProps.string.isRequired,
    target: smartProps.string.isRequired.withDefault(""),
    event: smartProps.string.isRequired,
  };

  sendPopupEvent = () => {
    let event;
    if (this.props.eventData)
      event = new CustomEvent("toggle-popup-" + this.props.event, {
        detail: this.props.eventData,
      });
    else event = new CustomEvent("toggle-popup-" + this.props.event);
    document.dispatchEvent(event);
  };

  static renderEdit(wpProps) {
    return (
      <div>
        <PlainText
          onChange={(content) => wpProps.setAttributes({ buttonText: content })}
          value={wpProps.attributes.buttonText}
          placeholder="Button text"
          className="content pedrini-button"
        />
        <PlainText
          onChange={(content) => wpProps.setAttributes({ buttonUrl: content })}
          value={wpProps.attributes.buttonUrl}
          placeholder="Button url"
        />
      </div>
    );
  }

  render() {
    if (this.props.event) {
      return (
        <button
          className={"plus-button " + this.props.color}
          onClick={() => {
            this.sendPopupEvent();
          }}
        >
          {this.props.buttonText}
        </button>
      );
    } else {
      return (
        <a href={this.props.buttonUrl} target={this.props.target}>
          <button className={"plus-button " + this.props.color}>
            {this.props.buttonText}
          </button>
        </a>
      );
    }
  }
}
